import { TextArea } from '../NarusMaterial/TextArea'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const TextAreaField = ({ onChange, ...restProps }) => {
  const handleOnChange = event => {
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <TextArea
      {...restProps}
      onChange={handleOnChange}
    />
  )
}

export const TextAreaInput = makeAutobindedInput(
  makeValidatedInput(TextAreaField)
)
